/**
 * Shown when the renderer never starts (q-website-review-v4-fixes B4): the browser gave us no
 * WebGL/WebGPU context, usually because hardware acceleration is off, or the Game constructor
 * threw. It replaces the loading screen, which otherwise held forever with no way out, says what
 * happened, and offers a retry plus two ways back to the site.
 */
export const RENDERER_START_FAILED_LINKS = {
  site: 'https://thegreatcloudgame.life/world/',
  updates: 'https://thegreatcloudgame.life/world/#waitlist',
} as const;

export function RendererStartFailedNotice() {
  return (
    <div className="renderer-lost" role="alert">
      <h2>This browser couldn’t start the game’s 3D graphics</h2>
      <p>
        The game needs WebGL, which this browser didn’t provide. Turning on hardware acceleration in
        your browser settings, updating the browser or trying another one usually fixes it.
      </p>
      <p className="renderer-lost-actions">
        <button type="button" onClick={() => window.location.reload()}>
          Try again
        </button>
        <a href={RENDERER_START_FAILED_LINKS.site}>Back to The Great Cloud</a>
        <a href={RENDERER_START_FAILED_LINKS.updates}>Get monthly MMORPG updates</a>
      </p>
    </div>
  );
}
